import { useState } from "react";
import { useAuditLogs } from "@/hooks/useAuditLogs.js";
import { Input } from "@/components/ui/input.js";
import { Label } from "@/components/ui/label.js";
import { Table, TableHead, TableBody, TableRow, TableHeader, TableCell } from "@/components/ui/table.js";
import { Badge } from "@/components/ui/badge.js";

const OP_TONE: Record<"INSERT" | "UPDATE" | "DELETE", "success" | "warn" | "risk"> = {
  INSERT: "success",
  UPDATE: "warn",
  DELETE: "risk",
};

export default function Audit(): JSX.Element {
  const [table, setTable] = useState("");
  const [rowId, setRowId] = useState("");
  const filters = { ...(table ? { table_name: table } : {}), ...(rowId ? { row_id: rowId } : {}), limit: 100 };
  const { data } = useAuditLogs(filters);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-h1 font-display text-ink">Audit log</h1>
        <p className="text-body text-ink-soft">Append-only · accessibile da ruolo `reviewer` e superiori</p>
      </header>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-[1fr_1fr]">
        <div className="space-y-1.5">
          <Label htmlFor="table">Tabella</Label>
          <Input id="table" placeholder="listings / inquiries / approvals..." value={table} onChange={(e) => setTable(e.target.value)} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="row">Row id</Label>
          <Input id="row" placeholder="uuid" value={rowId} onChange={(e) => setRowId(e.target.value)} />
        </div>
      </div>

      <div className="overflow-x-auto rounded border border-rule bg-surface">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader className="w-[180px]">Quando</TableHeader>
              <TableHeader className="w-[100px]">Op</TableHeader>
              <TableHeader className="w-[160px]">Tabella</TableHeader>
              <TableHeader>Row</TableHeader>
              <TableHeader className="w-[180px]">Attore</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data?.items ?? []).map((row) => (
              <TableRow key={String(row.id)}>
                <TableCell className="font-mono text-meta text-ink">{new Date(row.created_at).toLocaleString("it-IT")}</TableCell>
                <TableCell><Badge tone={OP_TONE[row.op]}>{row.op}</Badge></TableCell>
                <TableCell className="font-mono text-meta uppercase text-ink-soft">{row.table_name}</TableCell>
                <TableCell className="font-mono text-meta text-ink-mute truncate">{row.row_id}</TableCell>
                <TableCell className="font-mono text-meta text-ink-mute">{row.actor_id ?? "—"}</TableCell>
              </TableRow>
            ))}
            {(data?.items ?? []).length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="py-12 text-center text-ink-mute">Nessun evento.</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
